import { balancedPalette, ColorPalette, monoBluePalette, vibrantPalette } from '@/entities/chart';

export const chartPaletteSelection = [
  {
    id: ColorPalette.Vibrant,
    name: 'Vibrant',
    palette: vibrantPalette,
    paletteImage: '/img/palettes/vibrantPalette.svg'
  },
  {
    id: ColorPalette.Monochrome,
    name: 'Blue monochrome',
    palette: monoBluePalette,
    paletteImage: '/img/palettes/monobluePalette.svg'
  },
  {
    id: ColorPalette.Balanced,
    name: 'Balanced',
    palette: balancedPalette,
    paletteImage: '/img/palettes/balancedPalette.svg'
  }
];
